import {
    Datagrid,
    DateInput,
    downloadCSV,
    NumberField,
    SelectInput,
    SimpleList,
    TextField,
    DateField,
    ReferenceField,
    FunctionField,
} from 'react-admin';
import jsonexport from 'jsonexport/dist';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme, Chip } from '@mui/material';
import { UploadButton } from '@components/UploadButton';
import { shortOptions } from '@src/helpers/date.ext';
import { dataObject } from '@src/object.type';
import env from '@src/environment';
import { orderStatus } from '@src/entityResource';

const filters = [
    <DateInput
        key="createdAt"
        source="createdAt"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
    />,
    <SelectInput
        key="transactionStatus"
        source="transactionStatus"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
        choices={orderStatus}
    />,
];

export const OrderList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );

    const exporter = (goods: dataObject[]) => {
        const orderDetailExport = goods.map(od => {
            const {
                createdAt,
                user,
                schedule,
                invoiceNo,
                transactionStatus,
                transactionType,
                transactionAmount,
                transactionCost,
                transactionMargin,
                zakat,
                incentiveMargin,
                incentiveAmount,
            } = od;
            const u = user as unknown as dataObject;
            const s = schedule as unknown as {
                [key: string]: string | number | object;
            };
            const st = s.store as unknown as dataObject;

            return {
                ['Tgl Order']: createdAt,
                Sales: u.name,
                Toko: st.name,
                ['No Invoice']: invoiceNo,
                Status: transactionStatus,
                Tipe: transactionType,
                Total: transactionAmount,
                Biaya: transactionCost,
                Margin: transactionMargin,
                Zakat: zakat,
                ['Ins (%)']: incentiveMargin,
                ['Ins (Rp)']: incentiveAmount,
            };
        });

        jsonexport(
            orderDetailExport,
            {
                headers: [
                    'Tgl Order',
                    'Sales',
                    'Toko',
                    'No Invoice',
                    'Status',
                    'Tipe',
                    'Total',
                    'Biaya',
                    'Margin',
                    'zakat',
                    'Ins (%)',
                    'Ins (Rp)',
                ],
            },
            (err, csv) => {
                downloadCSV(
                    csv,
                    `pesanan_${new Date().toLocaleString(env.localFormat)}`
                );
            }
        );
    };

    return (
        <InfiniteList
            uploadButton={<UploadButton />}
            exporter={exporter}
            filtersNodes={filters}
        >
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.address}
                    tertiaryText={record => record.phone}
                />
            ) : (
                <Datagrid>
                    <DateField
                        source="createdAt"
                        locales={env.localFormat}
                        options={shortOptions}
                    />
                    <ReferenceField source="createdBy" reference="users">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField
                        source="schedule.store.id"
                        reference="store"
                    >
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="invoiceNo" />
                    <FunctionField
                        source="transactionStatus"
                        render={r => (
                            <Chip
                                label={r.transactionStatus}
                                className={r.transactionStatus}
                            />
                        )}
                    />
                    <TextField source="transactionType" />
                    <NumberField source="transactionAmount" />
                    <NumberField source="transactionCost" />
                    <NumberField source="transactionMargin" />
                    <NumberField source="zakat" />
                    <NumberField source="incentiveMargin" />
                    <NumberField source="incentiveAmount" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
